module.exports = __webpack_public_path__ + "img/csr3.24f956bf.jpeg";